module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="formLine  index_100_ddkswwwxww ">\r\n    <div class="form-group col-xs-3 inputField">\r\n        <select id="fieldname" class="form-control">\r\n            <option value="">--</option>\r\n            <option value="operacion" ';
 if(filters.fieldname=="operacion") print("selected='selected'")
__p+=' >'+
((__t=(lang.ACTION))==null?'':_.escape(__t))+
'</option>\r\n            <option value="usuariomodificador" ';
 if(filters.fieldname=="usuariomodificador") print("selected='selected'")
__p+=' >'+
((__t=(lang.MODIFICADO_POR))==null?'':_.escape(__t))+
'</option>\r\n            <option value="fecha_modificado" ';
 if(filters.fieldname=="fecha_modificado") print("selected='selected'")
__p+=' >'+
((__t=(lang.LAST_MODIFICATION))==null?'':_.escape(__t))+
'</option>\r\n            <option value="tipocambio" ';
 if(filters.fieldname=="tipocambio") print("selected='selected'")
__p+=' >'+
((__t=(lang.TYPE_MODIFICATION))==null?'':_.escape(__t))+
'</option>            \r\n        </select>\r\n    </div>\r\n    <div class="form-group col-xs-2 inputField" id="operatorHolder">\r\n        <select id="nbcomparador" class="form-control operator ';
 if(filters.nbfield!="nbcomparador") print("hidden")
__p+='" >\r\n            <option value="<" ';
 if(filters.nbcomparador=="<") print("selected='selected'")
__p+=' >'+
((__t=(lang.MENOR_QUE))==null?'':_.escape(__t))+
'</option>\r\n            <option value="=" ';
 if(filters.nbcomparador=="=") print("selected='selected'")
__p+=' >'+
((__t=(lang.IGUAL_A))==null?'':_.escape(__t))+
'</option>\r\n            <option value=">" ';
 if(filters.nbcomparador==">") print("selected='selected'")
__p+=' >'+
((__t=(lang.MAYOR_QUE))==null?'':_.escape(__t))+
'</option>\r\n        </select>\r\n        <select id="nbIgual" class="form-control operator ';
 if(filters.nbfield!="nbIgual" && filters.nbfield) print("hidden")
__p+='" >\r\n            <option value="=" selected>'+
((__t=(lang.IGUAL_A))==null?'':_.escape(__t))+
'</option>\r\n        </select>\r\n        <select id="nbIncluye" class="form-control operator ';
 if(filters.nbfield!="nbIncluye") print("hidden")
__p+='" >\r\n            <option value="like" selected>'+
((__t=(lang.INCLUYE))==null?'':_.escape(__t))+
'</option>\r\n        </select>\r\n    </div>\r\n    <div class="form-group col-xs-3 inputField" id="valueHolder">        \r\n        <input type="text" id="textValue" class="form-control value ';
 if(filters.valuefield!="textValue" && filters.valuefield) print("hidden")
__p+=' " value="';
 if(filters.valuefield=="textValue") print(filters.value)
__p+='" />\r\n        <input type="number" id="numberValue" step="0.001" class="form-control value ';
 if(filters.valuefield!="numberValue") print("hidden")
__p+='" value="';
 if(filters.valuefield=="numberValue") print(filters.value)
__p+='" />\r\n        <div id=\'dtpickerBuscar\' class="input-group dateGroup ';
 if(filters.valuefield!="dateValue") print("hidden")
__p+='">\r\n            <input type=\'text\' id="dateValue" name="start" class="form-control date value" value="';
 if(filters.valuefield=="dateValue") print(filters.value)
__p+='" />\r\n            <span class="input-group-addon">\r\n                <span class="glyphicon glyphicon-calendar"></span>\r\n            </span>\r\n        </div>\r\n        <select id="tipeOperaci" class="form-control value ';
 if(filters.valuefield!="tipeOperaci") print("hidden")
__p+='">\r\n                <option ';
 if(filters.value=="Create") print("selected='selected'")
__p+=' value="Create">'+
((__t=(lang.CREATE))==null?'':_.escape(__t))+
'</option>\r\n                <option ';
 if(filters.value=="Update") print("selected='selected'")
__p+=' value="Update">'+
((__t=(lang.UPDATE))==null?'':_.escape(__t))+
'</option>\r\n                <option ';
 if(filters.value=="Delete") print("selected='selected'")
__p+=' value="Delete">'+
((__t=(lang.DELETE_A))==null?'':_.escape(__t))+
'</option> \r\n        </select>\r\n        <select id="typeCambio" class="form-control value ';
 if(filters.valuefield!="typeCambio") print("hidden")
__p+='">\r\n                <option ';
 if(filters.value=="masivo") print("selected='selected'")
__p+=' value="value="masivo">'+
((__t=(lang.MASIVO))==null?'':_.escape(__t))+
'</option>                \r\n                <option ';
 if(filters.value=="individual") print("selected='selected'")
__p+=' value="individual">'+
((__t=(lang.INDIVIDUAL))==null?'':_.escape(__t))+
'</option> \r\n        </select>        \r\n        \r\n    </div>\r\n    <div class="form-group col-xs-2 inputField">\r\n        <select id="operator" class="form-control">\r\n            <option ';
 if(filters.operator!="and" && filters.operator!="or") print("selected='selected'")
__p+=' >--</option>\r\n            <option value="and" ';
 if(filters.operator=="and") print("selected='selected'")
__p+=' >'+
((__t=(lang.AND))==null?'':_.escape(__t))+
'</option>\r\n            <option value="or" ';
 if(filters.operator=="or") print("selected='selected'")
__p+=' >'+
((__t=(lang.OR))==null?'':_.escape(__t))+
'</option>\r\n        </select>\r\n    </div>\r\n    <div class="form-group col-xs-2">\r\n        <span class="searchButton add ion ion-ios-plus text-green"></span>\r\n        ';
 if(showremove){ 
__p+=' \r\n        <span class="searchButton remove ion-ios-close text-red"></span>\r\n        ';
 } 
__p+='\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/logs/formLine.ejs
// module id = 428
// module chunks = 0